<template>
    <div>
        <el-date-picker @change="pick" v-model="startAt" :picker-options="pickerOptions"
		type="month" size="small" style="width:120px" value-format="yyyy-MM" append-to-body />
        <span>~</span>
        <el-date-picker @change="pick" v-model="endAt" :picker-options="pickerOptions" 
		type="month" size="small" style="width:120px" value-format="yyyy-MM" append-to-body />
    </div>
</template>

<script>
export default {
	props:['value'],
	data(){
		const self = this;
		const getMonthDate = self.$utils.getMonthDate;
		const date_format = self.$utils.date_format;
		function getMonthDateStr(bias){
			const d = getMonthDate(bias);
			return date_format(d,'YYYY-MM');
		}
		function onClickGen(bias){
			return function(picker){
				const month = getMonthDateStr(bias);
				picker.$emit('pick','');
				self.startAt = self.endAt = month;
			}
		}
		return{
			startAt:getMonthDateStr(-1),
			endAt:getMonthDateStr(-1),
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
				shortcuts: [
					{
						text: 'lastMonth',
						onClick:onClickGen(-1),
					},
					{
						text:'-2 Month',
						onClick:onClickGen(-2),
					},
					{
						text:'-3 Month',
						onClick:onClickGen(-3),
					},
					{
						text:'-4 Month',
						onClick:onClickGen(-4),
					}
				]
			}
		}
	},
	methods:{
		pick(){
			let value = '';
			if(this.startAt || this.endAt){
				value = {};
				if(this.startAt){
					value['$gte'] = new Date(this.startAt).getTime()/1000;
				}
				if(this.endAt){
					value['$lt'] = this.$utils.getMonthDate(1,true,new Date(this.endAt));
				}
				this.$emit('input',value);
			} else {
				this.$emit('input','');
			}
			
		}
	},
	mounted(){
		this.pick();
	}
}
</script>
<style scoped>
</style>

